<template>
  <div id="adminSelenaViews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Spese di spedizione</router-link>
      </li>
    </ol>
    
    <div class="container-fluid card-title-admin">
      <div class="row">
          <div class="col-6 align-self-center">
            <h1>Spese di spedizione</h1>
          </div>
          <div class="col-6 align-self-center text-right">
            <button 
              v-if="rowIdSelected!='' || newRow"
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="cancelNewNation"
            >{{ cancel }}</button>
            <button
              v-if="rowIdSelected!='' || newRow"
              type="button"
              class="btn btn-success"
              @click="saveNewNation"
            >{{ save }}</button>
          </div>
        </div>
    </div>
     <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-lg-12 text-left">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onClickNew"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckCustomer"
                :results="tableNationResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabNationDetail" role="tabpanel" style="padding-left: 40px;padding-right: 40px;">
            <div class="row">
              <div class="col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <button
                      id="tabAdminInformationCarriers"
                      class="nav-link active"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminInformationCarriersTab"
                      role="tab"
                      aria-controls="tabAdminInformationCarriersTab"
                      v-on:click="onInformationCarriersTab"
                    >
                      <span>Informazioni</span>
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      v-if="rowIdSelected!=''"
                      id="tabAdminTaxCarriersCarriers"
                      class="nav-link"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminTaxCarriersCarriersTab"
                      role="tab"
                      aria-controls="tabAdminTaxCarriersCarriersTab"
                      v-on:click="onTaxCarriersTab"
                    >
                      <span>Tariffe</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content">
              <!-- TAB INFORMAZIONI -->
              <div class="card-body tab-pane active" id="DetailInformationCarriers" role="tabpanel" style="padding-left: 40px;padding-right: 40px;">
                <div class="row">
                 <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                  <pageDetail
                    functions="AdminSettingNation"
                    :configurations="detailNationConfiguration"
                    :jsonValue="detailNationData"
                  ></pageDetail>
                </div>
              </div>
              <!-- END TAB INFORMAZIONI -->
              <!-- TAB TARIFFE -->
              <div class="card-body tab-pane" id="DetailTaxCarriers" role="tabpanel" style="padding: 15px;">
                <div class="row row-area">
                  <div class="col-1 align-self-center">
                    <h6>Area</h6>
                  </div>
                  <div class="col-2 align-self-center">
                    <label v-if="detailNationData.nation_id" style="display: inline;">
                      <input type="radio" checked="checked" :name="'radio' + detailNationData.id" style="margin: 5px;" value="nation_id">
                      <span class="checkmark"></span>&nbsp;Stato
                    </label>
                    <label v-else style="display: inline;">
                      <input type="radio" :name="'radio' + detailNationData.id" style="margin: 5px;" value="nation_id" @click="changeZoneDetailArea(detailNationData.id)">
                      <span class="checkmark"></span>&nbsp;Stato
                    </label>
                  </div>
                  <div class="col-2 align-self-center">
                    <label v-if="detailNationData.region_id" style="display: inline;">
                      <input type="radio" checked="checked" :name="'radio' + detailNationData.id" style="margin: 5px;" value="region_id">
                      <span class="checkmark"></span>&nbsp;Regione
                    </label>
                    <label v-else style="display: inline;">
                      <input type="radio" :name="'radio' + detailNationData.id" style="margin: 5px;" value="region_id" @click="changeZoneDetailArea(detailNationData.id)">
                      <span class="checkmark"></span>&nbsp;Regione
                    </label>
                  </div>
                  <div class="col-2 align-self-center">
                    <label v-if="detailNationData.province_id" style="display: inline;">
                      <input type="radio" checked="checked" :name="'radio' + detailNationData.id" style="margin: 5px;" value="province_id">
                      <span class="checkmark"></span>&nbsp;Provincia
                    </label>
                    <label v-else style="display: inline;">
                      <input type="radio" :name="'radio' + detailNationData.id" style="margin: 5px;" value="province_id" @click="changeZoneDetailArea(detailNationData.id)">
                      <span class="checkmark"></span>&nbsp;Provincia
                    </label>
                  </div>
                </div>
                <div class="row row-area" style="border-bottom:4px dashed #ededed;">
                  <div class="col-1 align-self-center">
                      <h6>Seleziona</h6>
                    </div>
                  <div class="col-4 align-self-center" >
                    <!--select2
                      id="select_areacarrier"
                      ref="select_areacarrier"
                      class="form-control nopadding"
                      style="width:75%"
                      :filterable="false"
                      :service="serviceAreas"  
                      v-model="serviceAreas" 
                      /-->
                      <select id="select_areacarrier" 
                      ref="select_areacarrier"
                      class="form-control nopadding"
                      style="width:75%"></select>
                  </div>
                  <div class="col-2 align-self-center" >
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="addNewCarrierArea"
                    ><i class="fa fa-plus"></i>Aggiungi area</button>
                  </div>
                </div>
                <div class="row row-area" style="border-bottom:2px dashed #ededed;" v-for="dataCarrierAreas in dataCarrierArea" v-bind:key="dataCarrierAreas.id">
                  <div class="col-6 align-self-center">
                    <h5>{{ dataCarrierAreas.zone }}</h5>
                  </div>
                  <div class="col-6 text-right align-self-center">
                    <button class="btn btn-primary" @click="addNewDetailArea(dataCarrierAreas.id)">AGGIUNGI RANGE</button>
                  </div>
                  <div class="col-12">
                    <div class="row div-row-detail-carrier-area" v-for="dataCarrierAreaDetails in dataCarrierAreas.carrierAreaListPrice" v-bind:key="dataCarrierAreaDetails.id">
                      <div class="col-1 align-self-center">
                        <label>Da<br> <font style="font-size:10px;">(maggiore o uguale)</font></label>
                      </div>
                      <div class="col-2 align-self-center">
                        <input type="number" @change="updateDetailArea(dataCarrierAreas.id, dataCarrierAreaDetails.id)" class="form-control" :id="'from-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :name="'from-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :value="dataCarrierAreaDetails.from">
                      </div>
                      <div class="col-1 align-self-center">
                        <label>A <br><font style="font-size:10px;">(minore)</font></label>
                      </div>
                      <div class="col-2 align-self-center">
                        <input type="number" @change="updateDetailArea(dataCarrierAreas.id, dataCarrierAreaDetails.id)" class="form-control" :id="'to-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :name="'to-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :value="dataCarrierAreaDetails.to">
                      </div>
                      <div class="col-1 align-self-center">
                        <label>Importo</label>
                      </div>
                      <div class="col-2 align-self-center">
                        <input type="number" @change="updateDetailArea(dataCarrierAreas.id, dataCarrierAreaDetails.id)" class="form-control" :id="'price-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :name="'price-' + dataCarrierAreas.id + '-' + dataCarrierAreaDetails.id" :value="dataCarrierAreaDetails.price">
                      </div>
                      <div class="col-3 align-self-center">
                        <button class="btn btn-danger" @click="deleteRangeDetailArea(dataCarrierAreaDetails.id)"><i class="fa fa-trash"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- END TAB TARIFFE -->
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";
export default {
  name: "adminSelenaViews",
  components: {
    BootstrapTable,
    PageDetail,
    Select2
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      detailNationConfiguration: [],
      tableNationResult: [],
      detailNationData: {},
      tableConfiguration: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname,
      serviceAreas: 'regions',
      dataCarrierArea: [],
      rowIdSelected:'',
      newRow : false
    };
  },
  created() {
    var adminSelenaViews = this;

    spinnerHelpers.show();
    adminSelenaViews.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      adminSelenaViews.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminSelenaViews.detailNationConfiguration = result.data.tabsConfigurations[0].pageConfigurations;

      adminSelenaViews.loadTable();
    });
  },
  methods: {
    onInformationCarriersTab: function () {
      var adminCrmItems = this;
      $("#DetailInformationCarriers").addClass("active");
      $("#DetailTaxCarriers").removeClass("active");
    },
    onTaxCarriersTab: function () {
      var adminCrmItems = this;
      $("#DetailInformationCarriers").removeClass("active");
      $("#DetailTaxCarriers").addClass("active");
      adminCrmItems.loadTaxCarriers();
      adminCrmItems.changeZoneSelect();
    },
    loadTable(ln) {
      var adminSelenaViews = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }
      
      carrierServices.getAll(ln,function(result) {
        adminSelenaViews.tableData = result.data;

        //if(adminSelenaViews.newRow){
        if (functionHelpers.isValued(adminSelenaViews.rowIdSelected)) {
          $.each(adminSelenaViews.tableData, function(i, row) {
            if (adminSelenaViews.rowIdSelected == row.id) {
              adminSelenaViews.detailNationData = row;
            }
          });
        }

        spinnerHelpers.hide();
      });
      
    },
    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminSelenaViews = this;
      adminSelenaViews.loadTable(value);
      spinnerHelpers.hide();

    },
    CarriersFormatter(value, row, index, field) {
      var adminSelenaViews = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminSelenaViews.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminSelenaViews.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      return html;
    },

    viewDatailInfo(id){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function(i, row) {
        if (adminSelenaViews.rowIdSelected == row.id) {
          adminSelenaViews.detailNationData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      $("#DetailInformationCarriers").addClass("active");
      $("#DetailTaxCarriers").removeClass("active");
      spinnerHelpers.hide();

    },
    delete(id) {
      var adminSelenaViews = this;
      spinnerHelpers.show();
      carrierServices.del(id, function() {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        var ln = adminSelenaViews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSelenaViews.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },
    onClickNew() {
      spinnerHelpers.show();
      this.detailNationData = {};
      this.newRow = true;
      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();
    },
    cancelNewNation(){
      spinnerHelpers.show();
      this.detailNationData = {};
      this.rowIdSelected = '';
      this.newRow = false;
      $("#tabTable").addClass("active");
      $("#tabNationDetail").removeClass("active");
      spinnerHelpers.hide();
    },
    saveNewNation(){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.detailNationData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected)) {
        this.detailNationData.id = this.rowIdSelected;

        carrierServices.update(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.updateCompleted);
          adminSelenaViews.rowIdSelected = '';
          adminSelenaViews.loadTable();
          $('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');
        })
      } else {
        carrierServices.insert(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.insertCompleted);
          adminSelenaViews.rowIdSelected = result.data;
          adminSelenaViews.loadTable();
          adminSelenaViews.loadTaxCarriers();
          
          /*$('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');*/
        })
      }
    },
    /* tax carriers */
    loadTaxCarriers(){
      var adminSelenaViews = this;
      var radioButtonSelected = $("input[name=radio" + adminSelenaViews.rowIdSelected + "]:checked").val();
      var idZone = "0";
      switch (radioButtonSelected) {
        case 'nation_id':
          idZone = '0';
          break;
        case 'region_id':
          idZone = '1';
          break;
        case 'province_id':
          idZone = '2';
          break;
        default:
          idZone = '0';
          break;
      }
      // estrazione elenco per tendina area a seconda del flag a true in anagrafica carrier
      carrierServices.getCarrierArea(adminSelenaViews.rowIdSelected, idZone, function(result){
        adminSelenaViews.dataCarrierArea = result.data;
      });
    },
    addNewCarrierArea(){
      // aggiunta nuova area
      var adminSelenaViews = this;
      var radioButtonSelected = $("input[name=radio" + adminSelenaViews.rowIdSelected + "]:checked").val();
      var selectId = $('#select_areacarrier').val();
      var carrierId = adminSelenaViews.rowIdSelected;
      
      var data = {
        field: radioButtonSelected,
        fieldId: selectId,
        carrierId: carrierId
      }

      carrierServices.insertCarrierArea(data, function(result){
        adminSelenaViews.loadTaxCarriers();
        notificationHelpers.success("Area aggiunta correttamente");
      });
    },
    addNewDetailArea(id){
      var adminSelenaViews = this;
      var radioButtonSelected = $("input[name=radio" + adminSelenaViews.rowIdSelected + "]:checked").val();
      var selectId = id;
      var carrierId = adminSelenaViews.rowIdSelected;
      
      var data = {
        field: radioButtonSelected,
        fieldId: selectId,
        carrierId: carrierId
      }

      carrierServices.insertCarrierArea(data, function(result){
        adminSelenaViews.loadTaxCarriers();
        notificationHelpers.success("Range aggiunto correttamente");
      });
    },
    deleteRangeDetailArea(id){
      var adminSelenaViews = this;
      if (confirm("Sei sicuro di voler eliminare il range?")){
        carrierServices.deleteRangeDetailArea(id, function(result){
          adminSelenaViews.loadTaxCarriers();
          notificationHelpers.success("Range eliminato correttamente");
        });
      }
    },
    updateDetailArea(idNation, idRow){
      var adminSelenaViews = this;
      var from = $('#from-' + idNation + '-' + idRow).val();
      var to = $('#to-' + idNation + '-' + idRow).val();
      var price = $('#price-' + idNation + '-' + idRow).val();
      var data = {
        id: idRow,
        from: from,
        to: to,
        price: price
      }

      carrierServices.updateCarrierRangeArea(data, function(result){
        adminSelenaViews.loadTaxCarriers();
        notificationHelpers.success("Parametri aggiornati correttamente");
      });
    },
    changeZoneDetailArea(id){
      var adminSelenaViews = this;
      var zone = $("input[name=radio" + adminSelenaViews.rowIdSelected + "]:checked").val();
      var data = {
        id : adminSelenaViews.rowIdSelected,
        zone: zone
      }
      if (confirm("Cambiando zona verranno eliminati i dati caricati precedentemente, vuoi continuare?")){
        carrierServices.deleteZoneRangeDetailArea(data, function(result){
          adminSelenaViews.changeZoneSelect();
          
          adminSelenaViews.loadTable();
          adminSelenaViews.loadTaxCarriers();
          notificationHelpers.success("Cambio zona effettuato correttamente");
        });
      }
    },
    changeZoneSelect(){
      $('#select_areacarrier').val('');
      var adminSelenaViews = this;
      var url = configData.wsRootServicesUrl + '/api/v1/nation/select';
      var zone = $("input[name=radio" + adminSelenaViews.rowIdSelected + "]:checked").val();

      switch (zone) {
        case 'nation_id':
          url = configData.wsRootServicesUrl + '/api/v1/nation/select';
          break;
        case 'region_id':
          url = configData.wsRootServicesUrl + '/api/v1/regions/select';
          break;
        case 'province_id':
          //gestire province
          url = configData.wsRootServicesUrl + '/api/v1/provinces/select';
          break;
        default:
          url = configData.wsRootServicesUrl + '/api/v1/nation/select';
          break;
      }
      var searchParam = "";
      var initials = [];
      initials.push({
        id: '',
        text: '- Seleziona -'
      });
      $('#select_areacarrier').select2({
        data: initials,
        ajax: {
          url: url,
          data: function (params) {
            if(params.term==''){
              searchParam = '*';
            }else{
            searchParam = params.term;
            }
            var query = {
            search: searchParam
            }
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
              results: dataParse.data
            };
          }
        }
      });
    }
    /* end tax carriers */
  }
};
</script>
<style>

.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}
.row-area{
  padding-top:15px;
  padding-bottom:15px;
}

.row-area label{
  margin-right: 25px;
  color: #303c54;
  font-size: 13px;
  font-weight: lighter;
}

.row-area h6{
  font-size:15px;
  font-weight: bold;
  color:#303C54;
}
.row-area h5{
  font-size:18px;
  font-weight: bold;
  color:#303C54;
  text-transform:uppercase;
  font-weight: bold;
}
.div-row-detail-carrier-area{
  margin-bottom: 5px;
}
.nav-tabs .nav-item span{
  
  color: #fff;
}
.nav-tabs .nav-item {
  width: 50%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}

</style>
